// Dynamic styles based on theme - to be used with useThemedStyles.
export const createStyles = ({ ui: { colors, type, space, radius } }) => ({
	overlay: {
		flex: 1,
		backgroundColor: colors.overlay,
		justifyContent: 'center',
		alignItems: 'center',
		padding: space.lg,
	},
	overlayPressable: {
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
	},
	calendarCard: {
		backgroundColor: colors.surface,
		borderRadius: radius.hero,
		paddingVertical: space.md,
		paddingHorizontal: 14,
		width: '100%',
		maxWidth: 340,
		zIndex: 1,
	},
	stepHeader: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: space.md,
	},
	stepTitle: {
		...type.sectionTitle,
		color: colors.text,
	},
	backButton: {
		minHeight: 44,
		justifyContent: 'center',
		paddingHorizontal: 6,
	},
	backText: {
		...type.bodySmallSemibold,
		color: colors.accent,
	},
	headerSpacer: {
		width: 44,
	},
	nextButton: {
		minHeight: 44,
		justifyContent: 'center',
		paddingHorizontal: 6,
	},
	nextText: {
		...type.bodySmallSemibold,
		color: colors.accent,
	},
	headerLabel: {
		...type.tag,
		marginBottom: space.xs,
		color: colors.textSecondary,
	},
	stepContent: {
		marginBottom: space.sm,
	},
	stepSubheading: {
		...type.secondary,
		marginTop: 6,
		marginBottom: space.sm,
		textAlign: 'center',
		color: colors.textSecondary,
	},
	optionGrid: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
	},
	optionButton: {
		width: '31%',
		minHeight: 44,
		justifyContent: 'center',
		paddingHorizontal: 6,
		marginBottom: space.sm,
		borderRadius: radius.control,
		borderWidth: 1,
		borderColor: colors.borderStrong,
		backgroundColor: colors.card,
		alignItems: 'center',
	},
	optionButtonSelected: {
		backgroundColor: colors.primary,
		borderColor: colors.primary,
	},
	optionText: {
		...type.label,
		color: colors.text,
	},
	optionTextSelected: {
		color: colors.onPrimary,
	},
	classicHeader: {
		flexDirection: 'row',
		alignItems: 'flex-start',
		justifyContent: 'space-between',
		marginBottom: 10,
	},
	classicHeaderCompact: {
		flexDirection: 'column',
		alignItems: 'stretch',
	},
	classicHeaderColumn: {
		flex: 1,
		marginHorizontal: space.xs,
	},
	classicHeaderColumnCompact: {
		marginHorizontal: 0,
		marginBottom: space.sm,
	},
	classicHeaderColumnCompactLast: {
		marginBottom: 0,
	},
	weekdayRow: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginBottom: space.xs,
		paddingHorizontal: space.xs,
		marginTop: space.xs,
	},
	weekdayText: {
		...type.label,
		width: 32,
		textAlign: 'center',
		color: colors.textFaint,
	},
	weekRow: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginBottom: 6,
	},
	dayCell: {
		width: 40,
		height: 40,
		borderRadius: radius.chip,
		alignItems: 'center',
		justifyContent: 'center',
	},
	daySelected: {
		backgroundColor: colors.primary,
	},
	dayDisabled: {
		opacity: 0.35,
	},
	dayText: {
		...type.bodySmall,
		color: colors.text,
	},
	dayTextSelected: {
		...type.bodySmallSemibold,
		color: colors.onPrimary,
	},
	dayTextDisabled: {
		color: colors.textFaint,
	},
	cancelButton: {
		marginTop: space.sm,
		alignSelf: 'center',
		minHeight: 44,
		justifyContent: 'center',
		paddingHorizontal: space.sm,
	},
	cancelText: {
		...type.bodySmallSemibold,
		color: colors.accent,
	},
});
